/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Illustration/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import BuccalCenter from './BuccalCenter/index'
import FacialFrontal from './FacialFrontal/index'
import LeftBuccalNoRetractors from './LeftBuccalNoRetractors/index'
import LeftBuccalWithRetractors from './LeftBuccalWithRetractors/index'
import No from './No/index'
import React from 'react'
import RightBuccalNoRetractors from './RightBuccalNoRetractors/index'
import RightBuccalWithRetractors from './RightBuccalWithRetractors/index'
import SmileNoRetractors from './SmileNoRetractors/index'



/** @type {import('Simple/types.js').View} */
export default function Illustration({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Instructions/Illustrations/Illustration"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imageCaptureQuestionIllustrationValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'illustration',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: imageCaptureQuestionIllustrationValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SmileNoRetractors'}>
<SmileNoRetractors
  viewPath={`${viewPath}/SmileNoRetractors`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LeftBuccalWithRetractors'}>
<LeftBuccalWithRetractors
  viewPath={`${viewPath}/LeftBuccalWithRetractors`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RightBuccalWithRetractors'}>
<RightBuccalWithRetractors
  viewPath={`${viewPath}/RightBuccalWithRetractors`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LeftBuccalNoRetractors'}>
<LeftBuccalNoRetractors
  viewPath={`${viewPath}/LeftBuccalNoRetractors`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RightBuccalNoRetractors'}>
<RightBuccalNoRetractors
  viewPath={`${viewPath}/RightBuccalNoRetractors`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FacialFrontal'}>
<FacialFrontal
  viewPath={`${viewPath}/FacialFrontal`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BuccalCenter'}>
<BuccalCenter
  viewPath={`${viewPath}/BuccalCenter`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}